import { FC } from 'react';

import { AreaCard } from 'components/pages/Area/components/AreaCard';

import styles from './RecentlyExploredArea.module.scss';

import { AreaCardItem } from 'components/pages/Area/components/AreaCard/AreaCard';

interface RecentlyExploredAreaProps {
  cardItem: AreaCardItem | null;
}

export const RecentlyExploredArea: FC<RecentlyExploredAreaProps> = ({ cardItem }) => {
  if (!cardItem) return null;

  return (
    <div className={styles.root}>
      <p className={styles.text}>最近探索したエリア</p>
      <AreaCard cardItem={cardItem} />
    </div>
  );
};
